// Search Form Component - Extraído de global.js
// Carregar apenas em páginas com busca

class SearchForm extends HTMLElement{constructor(){super(),this.input=this.querySelector('input[type="search"]'),this.input&&(this.input.form.addEventListener("reset",this.onFormReset.bind(this)),this.input.addEventListener("input",debounce(e=>{this.onChange(e)},300).bind(this)))}shouldResetForm(){return!document.querySelector('[aria-selected="true"] a')}onFormReset(e){e.preventDefault(),this.shouldResetForm()&&(this.input.value="",this.input.focus())}}customElements.define("search-form",SearchForm);



